var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var openCount = 0;
var STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position',
];
var LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%',
};
var ScrollLock = (function (_super) {
    __extends(ScrollLock, _super);
    function ScrollLock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.originalStyles = {};
        return _this;
    }
    ScrollLock.prototype.componentDidMount = function () {
        var _this = this;
        ++openCount;
        if (openCount === 1 && document.body) {
            var target_1 = document.body;
            var scrollbarWidth = window.innerWidth - document.body.clientWidth;
            STYLE_KEYS.forEach(function (key) { return (_this.originalStyles[key] = target_1.style.getPropertyValue(key)); });
            if (this.props.detectScrollbars) {
                target_1.style.paddingRight = scrollbarWidth + "px";
            }
            Object.keys(LOCK_STYLES).forEach(function (rule) {
                var val = LOCK_STYLES[rule];
                target_1.style.setProperty(rule, val);
            });
        }
    };
    ScrollLock.prototype.componentWillUnmount = function () {
        var _this = this;
        --openCount;
        if (openCount === 0 && document.body) {
            var target_2 = document.body;
            STYLE_KEYS.forEach(function (rule) {
                return target_2.style.setProperty(rule, _this.originalStyles[rule]);
            });
        }
    };
    ScrollLock.prototype.render = function () {
        return null;
    };
    ScrollLock.defaultProps = { detectScrollbars: true };
    return ScrollLock;
}(React.Component));
export default ScrollLock;
//# sourceMappingURL=scroll-lock.js.map